/**
 * Last-line frontend guard for AI errors: only ever surface a message we know is
 * user-safe, otherwise a generic fallback. A raw 500 (especially with APP_DEBUG on)
 * comes back as { message: "<server path / stack trace>", exception, file, line, … }
 * with NO `reason` — reading its `message` would leak implementation detail, so we
 * hide it.
 *
 *   - Our AiFailure envelope always carries `reason` → its `message` is friendly.
 *   - A 422 validation response carries a friendly, intentional `message`.
 *   - Anything else (un-enveloped 500, network error) → the generic fallback.
 *
 * @param {*} error   The caught error (typically an Axios error).
 * @param {string} fallback  Message to show when nothing safe is available.
 * @returns {string}
 */
export function aiErrorMessage(error, fallback = 'Something went wrong with AI. Please try again.') {
    const res = error?.response;
    const data = res?.data ?? {};

    if (data.reason) {
        return data.message || fallback; // our AiFailure envelope (safe)
    }

    if (res?.status === 422 && typeof data.message === 'string') {
        return data.message; // friendly validation message
    }

    return fallback; // raw 500 / debug payload / network → hide
}
